import {
    FETCH_SAMPLES_LIST,
    FETCH_LOCATIONS_LIST,
    SAVE_SAMPLE,
    DELETE_SAMPLE,
    DELETE_MULTIPLE_SAMPLES,
    MODIFY_SAMPLE_DATA,
    FETCH_LOCATIONS_DATA,
    FETCH_RESULTS_LIST,
    DELETE_RESULT,
    DELETE_MULTIPLE_RESULTS,
    FETCH_FILTER_OPTIONS,
    FETCH_BUILDINGS_LIST,
    SAVE_BUILDING,
    DELETE_BUILDING,
    FETCH_FLOORS_LIST,
    FETCH_FLOOR_LIST,
    FETCH_FLOOR_PLAN,
    SAVE_FLOOR,
    DELETE_FLOOR,
    INITIAL_RESULT_STATE_DATA,
    FETCH_ROOMS_LIST,
    FETCH_ROOM_LIST,
    SAVE_ROOM,
    DELETE_ROOM,
    FETCH_COMPLEX_TYPE,
    FETCH_SPECIES_TYPE,
    UPDATE_RESULT_STATE,
    UPDATE_RESULT_STATE_FILTERS,
    INITIAL_LOCATION_STATE_DATA,
    UPDATE_LOCATION_STATE,
    UPDATE_LOCATION_STATE_FILTERS,
    FETCH_LOCATION_DATA,
    FETCH_SAMPLE_DATA,
    FETCH_RESULT_DATA,
    FETCH_RESULT_BIOME_DATA,
    FETCH_DASHBORD_DATA,
    FETCH_NOTIFICATIONS_LIST,
    DELETE_NOTIFICATION,
    SAVE_NOTIFICATION,
    MODIFY_NOTIFICATION_DATA,
    FETCH_NOTIFICATION_DATA,
    DELETE_MULTIPLE_NOTIFICATIONS,
    DELETE_MULTIPLE_LOCATIONS,
    MODIFY_RECURRENT_NOTIFICATIONS_DATA,
    FETCH_BATCH_NUMBERS,
    SEND_EMAIL,
    SAVE_WIKI_DATA,
    FETCH_WIKI_DATA,
    MODIFY_WIKI_DATA,
    DELETE_WIKI_DATA,
    SAVE_ANNOUNCEMENTS_DATA,
    GET_ANNOUNCEMENTS_DATA,
    FETCH_USER_PROFILE_DATA,
    SAVE_USER_PROFILE_DATA,
    UPDATE_USER_PROFILE_DATA,
    SAVE_LAB_DATA,
    FETCH_LOCATION_TREND_DATA
} from './types'
import Axios from "../apis/nodeServer";
import jwt_decode from "jwt-decode";
import axios from 'axios'

const headers = { headers: { 'Content-Type': 'multipart/form-data' } };
const sampleUrl = '/samples/';
const locationUrl = '/locations/';
const filterUrl = '/filters/';
const buildingUrl = '/buildings/';
const floorsUrl = '/floors/';
const roomsUrl = '/rooms/';
const unitsUrl = '/units/';
const resultsUrl = '/results/';
const notificationsUrl = '/notifications/';
const groupsUrl = 'groups/';
const emilUrl = 'mailsender/';
const acceptanceCriteriaUrl = 'acceptance-criteria/';
const labWikiUrl = 'labwiki/';
const userWikiUrl = 'userwiki/';
const announcemenstUrl = 'announcements/';
const userprofileUrl = 'userprofile/';
const labUrl = 'lab/';
const decoded = localStorage.getItem("auth_token") ? jwt_decode(localStorage.getItem("auth_token")) : null;
const role = decoded ? (decoded.roles ? decoded.roles[0] : decoded.lab || '') : '';

function updateLabtoRequest(data) {
    const decoded = jwt_decode(localStorage.getItem("auth_token"));
    const lab = decoded.roles ? decoded.roles[0] : decoded.lab || '';
    data = {...data, 'lab': lab};
    return data;
}

export const registerUser = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(process.env.REACT_APP_CUSTOM_URL + 'registration/', data, { headers: { 'Content-Type': 'application/json' } })
    return response
}

export const registerUserAD = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await axios.post(process.env.REACT_APP_CUSTOM_URL + 'registration_user/', data, { headers: { 'Content-Type': 'application/json' } })
    return response
}

export const getAllCustomLabs = () => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(process.env.REACT_APP_CUSTOM_URL + 'lab/', { headers: { 'Content-Type': 'application/json'}})
    return response
}

export const addCustomLabs = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(process.env.REACT_APP_CUSTOM_URL + 'lab/', data, { headers: { 'Content-Type': 'application/json'} })
    return response
}
export const addLabs = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(labUrl, data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: SAVE_LAB_DATA,
        payload: response.data
    })
    return response
}
export const saveUserProfile = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(userprofileUrl, data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: SAVE_USER_PROFILE_DATA,
        payload: response.data
    })
    return response
}
export const fetchUserProfile = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(userprofileUrl, { params: { ...params } })
    dispatch({
        type: FETCH_USER_PROFILE_DATA,
        payload: response.data,
        param: params
    })
    return response
}
export const updateUserProfile = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.put(userprofileUrl + data.id + '/', data, {headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: UPDATE_USER_PROFILE_DATA,
        payload: response.data,
    })
    return response
}
export const saveAnnouncements = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(announcemenstUrl, data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: SAVE_ANNOUNCEMENTS_DATA,
        payload: response.data
    })
    return response
}
export const getAnnouncements = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(announcemenstUrl, { params: { ...params } })
    dispatch({
        type: GET_ANNOUNCEMENTS_DATA,
        payload: response.data,
        param: params
    })
    return response
}
export const saveWiki = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(role=='Lab.Tech'? labWikiUrl: userWikiUrl, data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: SAVE_WIKI_DATA,
        payload: response.data
    })
    return response
}

export const getWiki = () => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(role == 'Lab.Tech' ? labWikiUrl : userWikiUrl)
    dispatch({
        type: FETCH_WIKI_DATA,
        payload: response.data
    })
    return response
}

export const updateWiki = (params) => async dispatch => {
    let data = params["data"]
    let nodeServer = Axios.instance;
    const response = await nodeServer.put((role=='Lab.Tech'? labWikiUrl: userWikiUrl) + params.id + '/', params, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: MODIFY_WIKI_DATA,
        payload: response.data
    })
    return response
}
export const deleteWiki = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete((role == 'Lab.Tech' ? labWikiUrl : userWikiUrl) + params + '/')
    dispatch({
        type: DELETE_WIKI_DATA,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const sendEmail = (params) => async dispatch => {
    var formData = new FormData()
    params = updateLabtoRequest(params);
    Object.keys(params).forEach((key) => {
        formData.append(key, params[key])
    })
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(emilUrl, formData, headers)
    dispatch({
        type: SEND_EMAIL,
        payload: response.data
    })
    return response
}

export const fetchNotificationsList = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(notificationsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_NOTIFICATIONS_LIST,
        payload: response.data,
    })
}

export const downloadnotificationData = () => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(notificationsUrl)
    dispatch({
        type: FETCH_NOTIFICATION_DATA,
        payload: response.data,
    })
    return response
}

export const saveNotification = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(notificationsUrl, data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: SAVE_NOTIFICATION,
        payload: response.data
    })
    return response
}
export const deleteNotification = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(notificationsUrl + params + '/')
    dispatch({
        type: DELETE_NOTIFICATION,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}
export const deleteMultipleNotifications = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(notificationsUrl + 'delete/', {
        params: { ...params }
    })
    dispatch({
        type: DELETE_MULTIPLE_NOTIFICATIONS,
        payload: response.data
    })
    return response
}
export const updateNotification = (params) => async dispatch => {
    params = params["data"]
    params = updateLabtoRequest(params);
    var formData = new FormData()
    Object.keys(params).forEach((key) => {
        if (key === 'datetime') {
            formData.append(key, new Date(params[key]).toISOString())
        }
        else {
            formData.append(key, params[key])
        }
    })
    let nodeServer = Axios.instance;
    const response = await nodeServer.put(notificationsUrl + params.id + '/', formData, headers)
    dispatch({
        type: MODIFY_NOTIFICATION_DATA,
        payload: response.data
    })
    return response
}

export const updateRecurrentNotifications = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.put(notificationsUrl + 'update_events/', data, { headers: { 'Content-Type': 'application/json' }})
    dispatch({
        type: MODIFY_RECURRENT_NOTIFICATIONS_DATA,
        payload: response.data
    })
    return response
}

export const fetchSamplesList = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(sampleUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_SAMPLES_LIST,
        payload: response.data,
        param: params
    })
    return response
}
export const fetchSampleCount = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get('/samplecount/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_DASHBORD_DATA,
        payload: response.data,
    })
}

export const fetchLocationTrend = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get('/risk/location-trend/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_LOCATION_TREND_DATA,
        payload: response.data,
    })
}

export const downloadSampleData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(sampleUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_SAMPLE_DATA,
        payload: response.data,
        param: params
    })
    return response
}

export const fetchLocationList = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'units/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_LOCATIONS_LIST,
        payload: response.data
    })
}

export const uploadSamples = (files = []) => async dispatch => {
    let formData = new FormData();
    formData.append('samples_file', files);
    let nodeServer = Axios.instance;
    const response = nodeServer.post(sampleUrl + 'upload/', formData, headers)
    return response
};

export const analyzeSanger = (files = []) => async dispatch => {
    let formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    let nodeServer = Axios.instance;
    const response = nodeServer.post('sanger/analyze/', formData, headers)
    return response
};

export const analyzeAgro = (files = [], blocksPerPlot = 1) => async dispatch => {
    let formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    formData.append('blocks_per_plot', blocksPerPlot);
    let nodeServer = Axios.instance;
    const response = nodeServer.post('agro/analyze/', formData, headers)
    return response
};

export const analyzeAuditoria = (file) => async dispatch => {
    let formData = new FormData();
    formData.append('file', file);
    let nodeServer = Axios.instance;
    const response = nodeServer.post('auditoria/analyze/', formData, headers)
    return response
};

export const uploadResults = (files = [], is_snp = false, is_biome = false) => async dispatch => {
    let formData = new FormData();
    formData.append('results_file', files);
    let nodeServer = Axios.instance;
    const response = nodeServer.post(resultsUrl + 'upload/', formData, { params: { is_snp: is_snp, is_biome: is_biome } }, headers)
    return response
};

export const singleResultUpload = (data) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = nodeServer.post(resultsUrl, data, { headers: { 'Content-Type': 'application/json' } })
    return response
}
export const saveSample = (params) => async (dispatch) => {
  var formData = new FormData();
  params = updateLabtoRequest(params);
  Object.keys(params).forEach((key) => {
    if (key === "date_time") {
      formData.append(key, new Date(params[key]).toISOString());
    } else {
      formData.append(key, params[key]);
    }
  });
  try
   {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(sampleUrl, formData, headers);
    dispatch({
      type: SAVE_SAMPLE,
      payload: response.data,
    });
    console.log(response)
    return response;
  } catch {
    {
      const request = indexedDB.open("DNA_Pathogen_Tracker", 1);
    //   request.onupgradeneeded = (event) => {
    //     let db = event.target.result;
    //     let store = db.createObjectStore("org_sample", {
    //         autoIncrement: true,
    //      })
    //     let index = store.createIndex("date_time", "date_time", {
    //     unique: true
    //      });
    //   };
      request.onerror = (event) => {
        console.error(`Database error: ${event.target.errorCode}`);
      };
      function insertSample(db, sample) {
        // create a new transaction
        const txn = db.transaction(["org_sample"], "readwrite");
        // get the Contacts object store
        const store = txn.objectStore(["org_sample"]);
        //
        let query = store.put(sample);
        // handle success case
        query.onsuccess = function (event) {
          console.log(event);
        };

                // handle the error case
                query.onerror = function (event) {
                    console.log(event.target.errorCode);
                };
                // close the database once the
                // transaction completes
                txn.oncomplete = function () {
                    db.close();
                };
            }

            request.onsuccess = (event) => {
                const db = event.target.result;
                insertSample(db, params);
            };
        }
    }
    finally {
    }
};
export const deleteSample = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(sampleUrl + params + '/')
    dispatch({
        type: DELETE_SAMPLE,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const deleteMultipleSamples = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(sampleUrl + 'delete/', { params: { 'ids': params.join(',') } })
    dispatch({
        type: DELETE_MULTIPLE_SAMPLES,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}


export const updateSample = (params) => async dispatch => {
    params = params["data"]
    params = updateLabtoRequest(params);
    var formData = new FormData()
    Object.keys(params).forEach((key) => {
        if (key === 'date_time') {
            formData.append(key, new Date(params[key]).toISOString())
        }
        else {
            formData.append(key, params[key])
        }
    })
    let nodeServer = Axios.instance;
    const response = await nodeServer.put(sampleUrl + params.id + '/', formData, headers)
    dispatch({
        type: MODIFY_SAMPLE_DATA,
        payload: response.data
    })
    return response
}

export const fetchLocationData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl, {
        params: { ...params }
    });
    dispatch({
        type: FETCH_LOCATIONS_DATA,
        payload: response.data
    })
    return response
}

export const fetchLocationResultsData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'results/', {
        params: { ...params }
    });
    dispatch({
        type: FETCH_LOCATIONS_DATA,
        payload: response.data
    })
    return response
}

export const fetchSNPMatrix = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'snp_results/', {
        params: { ...params }
    });
    return response
}

export const fetchSNPTrackingData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'track_snp_distance/', {
        params: { ...params }
    });
    return response
}
export const fetchGroups = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(groupsUrl + params.organism + '/')
    return response
}

export const getLocation = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + params + '/')
    return response
}

export const saveLocation = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    params[0] = updateLabtoRequest(params[0]);
    params[0]['room'] = parseInt(params[0]['room']);
    const response = await nodeServer.post(locationUrl, params)
    return response
}

export const deleteLocation = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(locationUrl + params.location_id + '/')
    return response
}
export const deleteMultipleLocations = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(locationUrl + 'delete/', { params: { 'ids': params.join(',') } })
    dispatch({
        type: DELETE_MULTIPLE_LOCATIONS,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const uploadLocation = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    var formData = new FormData();
    formData.append('location_file', params['location_file']);
    const response = await nodeServer.post(`/locations/upload/`, formData, headers)
    return response
}

export const fetchResultsList = (params, noPagination) => async dispatch => {
    let nodeServer = Axios.instance;
    // fetch results from api
    if (!noPagination) {
        if (params) {
            params['page_size'] = 5
        }
        else {
            params = { 'page_size': 5 }
        }
    }
    const response = await nodeServer.get(resultsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_RESULTS_LIST,
        payload: response.data,
        param: params
    })
    return response
}

export const downloadResultData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    // fetch results from api
    const response = await nodeServer.get(resultsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_RESULT_DATA,
        payload: response.data,
        param: params
    })
    return response
}

export const downloadBiomeResultData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    // fetch microbiome results from api
    const response = await nodeServer.get(resultsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_RESULT_BIOME_DATA,
        payload: response.data,
        param: params
    })
    return response
}

export const deleteMultipleResult = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(resultsUrl + 'delete/', { params: { 'ids': params.join(',') } })
    dispatch({
        type: DELETE_MULTIPLE_RESULTS,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const deleteResult = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(resultsUrl + params + '/')
    dispatch({
        type: DELETE_RESULT,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}


export const fetchLocationResultsTrackingData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'ctresults/', {
        params: { ...params }
    });
    dispatch({
        type: FETCH_LOCATIONS_DATA,
        payload: response.data
    })
    return response
}

export const fetchLocationResultsBiomeTrackingData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'biomeresults/', {
        params: { ...params }
    });
    dispatch({
        type: FETCH_LOCATIONS_DATA,
        payload: response.data
    })
    return response
}


export const fetchFilterOptions = () => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(filterUrl)
    dispatch({
        type: FETCH_FILTER_OPTIONS,
        payload: response.data
    })
}

export const fetchBuilding = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(buildingUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_BUILDINGS_LIST,
        payload: response.data
    })
}

export const deleteBuilding = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(buildingUrl + params + '/')
    dispatch({
        type: DELETE_BUILDING,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const saveBuilding = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.post(buildingUrl, updateLabtoRequest(params))
    dispatch({
        type: SAVE_BUILDING,
        payload: response.data
    })
    return response
}

export const fetchFloors = (data) => async dispatch => {
    dispatch({
        type: FETCH_FLOORS_LIST,
        payload: data
    })
}

export const fetchFloorPlan = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(floorsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_FLOOR_PLAN,
        payload: response.data
    })
}

export const fetchFloor = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(floorsUrl, {
        params: { ...params }
    })
    dispatch({
        type: FETCH_FLOOR_LIST,
        payload: response.data
    })
}

export const saveFloor = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    params = updateLabtoRequest(params);
    console.log('saveFloor: params after updateLabtoRequest:', params);
    let formData = new FormData();
    Object.keys(params).forEach((key) => { 
        // Skip lab field - backend generates it automatically in serializer
        if (key === 'lab') {
            console.log(`Skipping lab field (backend generates it)`);
            return;
        }
        console.log(`Appending to FormData: ${key} =`, params[key], typeof params[key]);
        formData.append(key, params[key]);
    });
    console.log('FormData entries:');
    for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
    }
    
    // For FormData, we should NOT set Content-Type manually - browser needs to set it with boundary
    // Remove Content-Type from headers to let browser set it automatically
    const formDataHeaders = {};
    console.log('Request headers (empty - browser will set Content-Type with boundary):', formDataHeaders);
    console.log('Request URL:', floorsUrl);
    
    try {
        const response = await nodeServer.post(floorsUrl, formData, formDataHeaders)
        console.log('Success response:', response);
        dispatch({
            type: SAVE_FLOOR,
            payload: response.data
        })
        return response
    } catch (error) {
        console.error('Error in saveFloor:', error);
        console.error('Error response:', error.response);
        console.error('Error response keys:', error.response ? Object.keys(error.response) : 'no response');
        if (error.response) {
            console.error('Error status:', error.response.status);
            console.error('Error statusText:', error.response.statusText);
            console.error('Error headers:', error.response.headers);
            
            // Try to get error data in multiple ways
            let errorData = error.response.data;
            console.error('Error data (raw):', errorData);
            console.error('Error data type:', typeof errorData);
            console.error('Error data is null?', errorData === null);
            console.error('Error data is undefined?', errorData === undefined);
            
            // Try to access data directly
            if (error.response.hasOwnProperty('data')) {
                console.error('error.response has data property');
            } else {
                console.error('error.response does NOT have data property');
            }
            
            // Try to see all properties
            console.error('All error.response properties:', Object.getOwnPropertyNames(error.response));
            
            if (errorData !== null && errorData !== undefined) {
                // Try to parse error data if it's a string
                if (typeof errorData === 'string') {
                    console.error('Error data (string):', errorData);
                    // Try to parse as JSON if it looks like JSON
                    try {
                        const parsed = JSON.parse(errorData);
                        console.error('Error data (parsed JSON):', parsed);
                        errorData = parsed;
                    } catch (e) {
                        console.error('Error data is not JSON:', e);
                    }
                } else if (typeof errorData === 'object') {
                    const errorDataStr = JSON.stringify(errorData, null, 2);
                    console.error('Error data (object):', errorDataStr);
                    // Try to extract field-specific errors
                    const errorKeys = Object.keys(errorData);
                    if (errorKeys.length > 0) {
                        console.error('Error fields:', errorKeys);
                        errorKeys.forEach(key => {
                            console.error(`  ${key}:`, errorData[key]);
                            // Check for non_field_errors (Django REST Framework format)
                            if (key === 'non_field_errors' && Array.isArray(errorData[key])) {
                                console.error('  non_field_errors:', errorData[key]);
                            }
                        });
                    } else {
                        console.error('Error data object is empty (no keys)');
                        // Try to see if it's an array
                        if (Array.isArray(errorData)) {
                            console.error('Error data is an array:', errorData);
                        }
                    }
                }
            } else {
                console.error('No error data in response (null or undefined)');
            }
            
            // Log full response for debugging
            try {
                console.error('Full error response (stringified):', JSON.stringify(error.response, null, 2));
            } catch (e) {
                console.error('Could not stringify error response:', e);
                console.error('Error response keys:', Object.keys(error.response));
            }
        } else {
            console.error('No error response object');
            console.error('Full error:', error);
            console.error('Error message:', error.message);
        }
        throw error;
    }
}

export const deleteFloor = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(floorsUrl + params + '/')
    dispatch({
        type: DELETE_FLOOR,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const deleteUnit = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(unitsUrl + params.id + '/')
    return response
}

export const saveUnit = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    params = updateLabtoRequest(params);
    const response = await nodeServer.post(unitsUrl, params)
    return response
}

export const fetchResultInitialState = () => dispatch => {
    dispatch({
        type: INITIAL_RESULT_STATE_DATA
    })
}

export const fetchRoomList = (data) => async dispatch => {
    dispatch({
        type: FETCH_ROOMS_LIST,
        payload: data
    })
}

export const fetchRooms = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(roomsUrl, {
        params: { ...params }
    });
    dispatch({
        type: FETCH_ROOM_LIST,
        payload: response.data,
    })
    return response
}

export const deleteRoom = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.delete(roomsUrl + params + '/')
    dispatch({
        type: DELETE_ROOM,
        payload: {
            data: params,
            response: response
        }
    })
    return response
}

export const saveRoom = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    params = updateLabtoRequest(params);
    let formData = new FormData();
    Object.keys(params).forEach((key) => { formData.append(key, params[key]) })
    const response = await nodeServer.post(roomsUrl, formData, headers)
    dispatch({
        type: SAVE_ROOM,
        payload: response.data
    })
    return response
}

export const downloadLocationData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'units/', {
        params: { ...params }
    }
    );
    dispatch({
        type: FETCH_LOCATION_DATA,
        payload: response.data,
        params: params
    })
    return response
}

export const fetchLocationUnitsData = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(locationUrl + 'units/', {
        params: { ...params }
    });
    dispatch({
        type: FETCH_LOCATIONS_DATA,
        payload: response.data,
        param: params
    })
    return response
}

export const fetchBatchNumbers = (params) => async dispatch => {
    params = params["data"]
    let nodeServer = Axios.instance;
    const response = await nodeServer.get('/batchno/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_BATCH_NUMBERS,
        payload: response.data
    })
}

export const fetchComplexTypes = (params) => async dispatch => {
    params = params["data"]
    let nodeServer = Axios.instance;
    const response = await nodeServer.get('/complextype/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_COMPLEX_TYPE,
        payload: response.data
    })
}

export const fetchSpeciesTypes = (params) => async dispatch => {
    params = params["data"]
    let nodeServer = Axios.instance;
    const response = await nodeServer.get('/specieslist/', {
        params: { ...params }
    })
    dispatch({
        type: FETCH_SPECIES_TYPE,
        payload: response.data
    })
}

export const updateResultState = (params) => dispatch => {
    dispatch({
        type: UPDATE_RESULT_STATE,
        payload: params.search
    })
}

export const updateResultStateFilters = (params) => dispatch => {
    dispatch({
        type: UPDATE_RESULT_STATE_FILTERS,
        payload: params
    })
}

export const fetchLocationInitialState = () => dispatch => {
    dispatch({
        type: INITIAL_LOCATION_STATE_DATA
    })
}

export const updateLocationState = (params) => dispatch => {
    dispatch({
        type: UPDATE_LOCATION_STATE,
        payload: params.search
    })
}

export const updateLocationStateFilters = (params) => dispatch => {
    dispatch({
        type: UPDATE_LOCATION_STATE_FILTERS,
        payload: params
    })
}

// ============================================================
// RISK MANAGEMENT ACTIONS
// ============================================================

export const fetchRiskData = (params) => {
    return dispatch => {
        return Axios.instance.get('risk/kpis/', { params })
            .then(response => {
                dispatch({ 
                    type: 'RISK_DATA_LOADED', 
                    payload: response.data 
                });
                return response;
            })
            .catch(error => {
                console.error('Error fetching risk data:', error);
                throw error;
            });
    };
};

export const calculateRisks = (params = {}) => {
    return dispatch => {
        return Axios.instance.post('risk/calculate/', params)
            .then(response => {
                dispatch({ 
                    type: 'RISKS_CALCULATED', 
                    payload: response.data 
                });
                return response;
            })
            .catch(error => {
                console.error('Error calculating risks:', error);
                throw error;
            });
    };
};

export const fetchRiskHeatmapData = (params) => {
    return dispatch => {
        return Axios.instance.get('risk/heatmap/', { params })
            .then(response => {
                dispatch({ 
                    type: 'RISK_HEATMAP_LOADED', 
                    payload: response.data 
                });
                return response;
            })
            .catch(error => {
                console.error('Error fetching heatmap data:', error);
                throw error;
            });
    };
};

export const fetchAcceptanceCriteria = (params) => async dispatch => {
    let nodeServer = Axios.instance;
    const response = await nodeServer.get(acceptanceCriteriaUrl, {
        params: { ...params }
    })
    return response
}